import { Route } from '@angular/router';
import { infrastructure } from './infrastructure';
import { rulesAndVerification } from './rulesAndVerification';
import { RoutingID } from '../../sb-routing-enum';
import { SbIcons } from '@ngx-seatback/icons';
import { marketing } from './marketing';

export const network: Route = {
  path: 'network',
  title: 'nav.network',
  data: {
    icon: SbIcons.network,
    breadcrumb: 'nav.network',
    id: RoutingID.network,
  },
  children: [
    {
      path: '',
      redirectTo: RoutingID.infrastructure,
      pathMatch: 'full',
      /* component: NetworkOverviewComponent,
      data: {
        breadcrumb: '',
      },*/
    },
    infrastructure,
    rulesAndVerification,
    marketing,
  ],
};
